module.exports = __webpack_public_path__ + "static/cowboys-logo_en.b637ab63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cowboys-logo_en.png
// module id = 423
// module chunks = 35783957827783